import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import { ROUTES } from './route-names'

export default (): RouteRecordRaw[] => {
  const { FF_ENABLE_BATTERY_REVIEWS_PAGE } = useRuntimeConfig().public

  return [
    {
      name: ROUTES.FORM,
      path: 'review/:orderlineId',
      component: () =>
        import('~/scopes/reviews/new-review-collection/ReviewCollection.vue'),
      meta: {
        layout: false,
        owners: ['bot-squad-content-front'],
        tracking: { contentGroup: 'Customer Support' },
      },
    },
    {
      name: ROUTES.PAGES.ALL,
      path: 'r',
      component: () =>
        import('~/scopes/reviews/reviews-display/pages/Reviews.vue'),
      meta: {
        owners: ['bot-squad-content-front'],
        tracking: { contentGroup: 'Reviews' },
      },
      children: [
        {
          name: ROUTES.PAGES.BATTERY,
          path: 'battery',
          component: () =>
            import('~/scopes/reviews/reviews-display/pages/Reviews.vue'),
          meta: {
            routeExists: () => !!FF_ENABLE_BATTERY_REVIEWS_PAGE,
            owners: ['bot-squad-content-front'],
            tracking: { contentGroup: 'Reviews' },
          },
        },
      ],
    },
  ]
}
